import PropTypes from 'prop-types'

import { Span } from 'components'

type Props = ISpan & {
  term: LeaseTerm
  termAmountOfMonths?: number
}
export const LeaseTerm: React.FC<Props> = ({ term, termAmountOfMonths, ...style }) => {
  const termsMap = {
    MONTHLY: 'Monthly',
    YEARLY: 'Yearly',
  }
  return (
    <Span {...style}>
      {term === 'AMOUNT_OF_MONTHS' ? `${termAmountOfMonths} month(s)` : termsMap[term]}
    </Span>
  )
}
LeaseTerm.propTypes = {
  term: PropTypes.oneOf<LeaseTerm>(['AMOUNT_OF_MONTHS', 'MONTHLY', 'YEARLY']).isRequired,
  termAmountOfMonths: PropTypes.number,
}

LeaseTerm.defaultProps = {
  termAmountOfMonths: 1,
}
